import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingModel } from 'app/_models/setting.model';
import { GenericService } from 'app/_services/generic.service';

@Injectable({
    providedIn: 'root',
})

export class SettingService extends GenericService<SettingModel> {
    constructor(private http: HttpClient) {
        super(http, '/Setting/')
    }
}